import {
  EventSegmentType,
  type EventSegmentType as EventSegmentTypeValue,
} from '@eti/schema-types';

export type TripInfoType =
  | Exclude<EventSegmentTypeValue, typeof EventSegmentType.Stop>
  | 'TECHNICAL_STOP';

export const PARTNER_EVENT_TYPES: TripInfoType[] = [
  EventSegmentType.ShortStopover,
  EventSegmentType.OneDayStopover,
  EventSegmentType.OneNightStopover,
  EventSegmentType.TwoNightsStopover,
];

export const EVENT_SEGMENT_TYPE_TO_TITLE_KEY: Record<TripInfoType, string> = {
  [EventSegmentType.OvernightStay]: 'TripDetails.Details.Overnight',
  [EventSegmentType.ChangeOfAirport]: 'TripDetails.Details.ChangeOfAirport',
  [EventSegmentType.TransferToAirport]: 'TripDetails.Details.TransferToAirport',
  [EventSegmentType.TransferToBus]: 'TripDetails.Details.TransferToBus',
  [EventSegmentType.TransferToTrain]: 'TripDetails.Details.TransferToTrain',
  [EventSegmentType.SelfTransfer]: 'SelfTransfer.Itinerary.Header.Text',
  [EventSegmentType.ShortStopover]: 'TripDetails.Details.StopoverInRome.ShortStopover.Title',
  [EventSegmentType.OneDayStopover]: 'TripDetails.Details.StopoverInRome.OneDayStopover.Title',
  [EventSegmentType.OneNightStopover]: 'TripDetails.Details.StopoverInRome.OneNightStopover.Title',
  [EventSegmentType.TwoNightsStopover]: 'TripDetails.Details.StopoverInRome.TwoNightsInRome.Title',
  TECHNICAL_STOP: 'OrderDetails.TravelInformation.TechnicalStop.Header',
};
